export const animaliaDetailDesignTokens = `
  :host {
    display: block;
    color: #202720;
  }

  * {
    box-sizing: border-box;
  }

  a {
    color: inherit;
  }

  .section-kicker,
  .field-label,
  .hero-pill,
  .status-kicker,
  .media-badge,
  .back-link {
    text-transform: uppercase;
    letter-spacing: 0.12em;
    font-size: 0.73rem;
  }

  .editorial-panel {
    border-radius: 24px;
    background: rgba(250, 247, 241, 0.92);
    border: 1px solid rgba(49, 70, 61, 0.12);
    box-shadow: 0 18px 38px rgba(31, 42, 35, 0.1);
  }
`;
